import React from 'react';
import { getUserName } from '../utils/userUtils';

export default function UserPill({ id, users = [], onRemove, style = {} }) {
  return (
    <span
      className="user-pill room-tag"
      style={{
        background: 'rgba(var(--color-primary-rgb), 0.08)',
        color: 'var(--color-primary)',
        border: '1px solid rgba(var(--color-primary-rgb), 0.2)',
        padding: '2px 8px',
        borderRadius: '0px',
        fontSize: '0.72rem',
        fontWeight: '600',
        display: 'inline-flex',
        alignItems: 'center',
        gap: '4px',
        ...style
      }}
    >
      {getUserName(users, id)}
      {onRemove && (
        <button
          type="button"
          className="btn-inline-delete-cross"
          style={{ padding: '0 0 0 4px', lineHeight: 1 }}
          onClick={(e) => {
            e.stopPropagation();
            onRemove(id);
          }}
          title="Remove user"
        >
          ×
        </button>
      )}
    </span>
  );
}
